import {
	Box,
	Button,
	Collapse,
	IconButton,
	TableCell,
	TableRow,
	Typography
} from "@mui/material";
import React from "react";
import useEmotionStyles from "@styles/shared/useEmotionStyles";
import { TestManageTableNStlye } from "@styles/shared/TestManageTableNStlye";

import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import '@mui/x-date-pickers/AdapterDayjs';
import clsx from "clsx";
import { ReactComponent as ManageCopyN } from '@common/images/ManageCopyN.svg';
import { ReactComponent as ManageEditN } from '@common/images/ManageEditN.svg';
import { ReactComponent as StepIconActiveN } from '@common/images/StepIconActiveN.svg';
import { ReactComponent as StepIconN } from '@common/images/StepIconN.svg';
// import 'dayjs/locale/ko';
import { convertUTCToKST } from "@hooks/convertUTCToKST";
import useNaviCustom from "@hooks/useNaviCustom";
import {
	convertSubjectNameTypeEnToKr,
	convertSubjectTypeEnToKr,
	ProjectSchoolLabelType
	} from "@stores/ProjectStore";
import { CustomTooltip } from "@components/layout/Tooltip";

import { useTranslation } from 'react-i18next';
import { useStores } from "@hooks/useStores";
import { IProject, IProjectPropertyReader } from "@repositories/model/IProject";
import { ProjectSchoolType } from "@stores/enums/ProjectStoreEnums";
import { ManagementButton } from "./ManagementButton";
import { useNeoConfirm } from "@hooks/useNeoConfirm";
import { codeUtil } from "@util/codeUtil";


type Props = {
	project: IProject,
	index: number,
	page: number,
	rowsPerPage: number,
	isForShared: boolean,
	openAssignments: boolean,
	expendable?: boolean,
	onClick: () => void,
	stepFilter: string
}

function TemplateProjectListRows(props: Props) {
	const { navigateStore, projectStore } = useStores();

	const i18next = useTranslation();
	const classes = useEmotionStyles( TestManageTableNStlye );
	const { project, index, page, rowsPerPage, isForShared, expendable, stepFilter } = props;

	const {alert, confirm} = useNeoConfirm();

	const [currentStep, setCurrentStep] = React.useState(null);
	// const [anchorEl2, setAnchorEl2] = React.useState(null);

	const naviCustom = useNaviCustom();

	// const handleClickTooltip2 = (event) => {
	// 	setAnchorEl2(event.currentTarget);
	// };
	// const handleClose2 = () => {
	// 	setAnchorEl2(null);
	// };

	// const openTool2 = Boolean(anchorEl2);
	// const id2 = openTool2 ? 'simple-popover' : undefined;

	// const handleClickProjectName = () => {
	// 	const { code } = project;
	// 	naviCustom.go(`/projects/${code}/create/info`);
	// 	// props.navigate(`/projects/${code}/create/info`);
	// }

	const handleEdit = () => {
		const { code, projectState } = project;
		console.log("projectState : ", projectState);

		if (projectState) {
			let currentStep: "info" | "exam" | "rubic" | "question" | "view" =
				(Object.keys(project.projectState)
					.filter(key => key === "info" || key === "exam" || key === "rubric")
					.find(key => !project.projectState[key])) as any;

			if (currentStep === "exam") {
				currentStep = "question";
			}
			if (!currentStep) {
				currentStep = "view";
			}

			naviCustom.go(`/projects/${code}/create/${currentStep}`);
			// props.navigate(`/projects/${code}/create/${currentStep}`);
		} else {
			props.onClick();
		}
	}

	const handleCopy = async (project) => {
		const result = await confirm(i18next.t(`[${project.name}] 프로젝트를 나의 평가 과제로 복제하시겠습니까?`));
		if (result) {
			projectStore.copyTemplate(project.code);
		}
	}

	const getStep = (label, active, isLast) => {
		return (
			<Box className={
				isLast ?
					active ? clsx(classes.stepIconBoxList, classes.stepIconActiveBox) : classes.stepIconBoxList
					: active ? clsx(classes.stepIconBox, classes.stepIconActiveBox) : classes.stepIconBox}>
				{active ? <StepIconActiveN /> : <StepIconN />}
				<Typography>{label}</Typography>
			</Box>
		);
	}

	React.useEffect(() => {
		if (project && project.projectState) {
			getCurrentStep();
		}
	}, [project.projectState, navigateStore.language]);

	const getCurrentStep = () => {
		let result;
		const { info, exam, rag, answer, rubric } = project.projectState;
		if (rubric) {
			result = i18next.t("평가 기준표");
		} else if (exam) {
			result = i18next.t("문항 생성")
		} else if (info) {
			result = i18next.t("과제 개요");
		} else {
			result = "-"
		}
		setCurrentStep(result);
	}

	const renderGradeTableCell = (project: IProject): JSX.Element => {

		let grade: string = ""
		let schoolType: ProjectSchoolType = ProjectSchoolType.NOGRADE;
		let gradelabel = "";

		// 2025.09.09
		if (IProjectPropertyReader.isBefore027Ver(project)) {
			const values = IProjectPropertyReader.before027VerCurriculumInfo(project);
			schoolType = values[0];
			grade = values[1];

			const isNoGrade = schoolType === ProjectSchoolType.NOGRADE;

			
			if (isNoGrade) {

				const result = codeUtil.mappedGradeStringAndSchoolString(grade);
				gradelabel = `${result[1]} ${result[0]}`;

			} else {
				gradelabel = i18next.t("{{grade}}학년", { grade: grade });
			}
			
		} else {
			const values = IProjectPropertyReader.after027VerCurriculumInfo(project);
			const school = values[0];
			grade = values[1];

			gradelabel = `${school} ${grade}`;
		}		
	
		return <TableCell>{gradelabel}</TableCell>;
	};

	const [showAssignments, setShowAssignments] = React.useState(props.openAssignments);
	React.useEffect(() => { setShowAssignments(props.openAssignments) }, [props.openAssignments]);
	const handleClickOpenAssignments = () => {
		setShowAssignments(!showAssignments);
	}

	return (
		<>
			<TableRow id={project.code} key={project.code} sx={{ '&:last-child .MuiTableCell-body': { border: '0px !important' } }}>

				{expendable &&
					<TableCell className={classes.tableNoBox}>
						<IconButton
							aria-label="expand row"
							size="small"
							onClick={handleClickOpenAssignments}
						>
							{showAssignments ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
						</IconButton>
					</TableCell>
				}

				<TableCell className={classes.tableNoBox}>
					{((page - 1) * rowsPerPage) + index + 1}
				</TableCell>
				<TableCell>
					<Button className={classes.tableStudentNameBtn}
						onClick={handleEdit}
						disableRipple>
						<Typography>{(project.name)}</Typography>
					</Button>
				</TableCell>
				{(!navigateStore.simpleMode) &&
					<TableCell> {i18next.t("{{curriculumYear}}년 개정", { curriculumYear: project.curriculumYear })} </TableCell>
				}
				{
                    renderGradeTableCell(project)
                }

                <TableCell> {IProjectPropertyReader.isBefore027Ver(project) ? convertSubjectTypeEnToKr(IProjectPropertyReader.before027VerCurriculumInfo(project)[2]) : IProjectPropertyReader.after027VerCurriculumInfo(project)[2]} </TableCell>
				
				{(!navigateStore.simpleMode) &&
					<TableCell> {IProjectPropertyReader.isBefore027Ver(project) ? convertSubjectNameTypeEnToKr(IProjectPropertyReader.before027VerCurriculumInfo(project)[2]) : IProjectPropertyReader.after027VerCurriculumInfo(project)[2]} </TableCell>
				}
				<TableCell> {convertUTCToKST(project.createdDatetime).format("YYYY-MM-DD")} </TableCell>
				{!isForShared &&
					<TableCell>
						<Box className={clsx(classes.stepIconBoxList, classes.stepIconActiveBox)}>
								{/*<StepIconActiveN/>*/}
								{currentStep}
							</Box>
						
					</TableCell>
				}
				<TableCell>
					{isForShared ?
						<ManagementButton label={"평가과제 복제"}
							button={<ManageCopyN />}
							onClick={() => handleCopy(project)} />
						:
						<ManagementButton label={"평가과제 편집"}
							button={<ManageEditN />}
							onClick={handleEdit} />
					}

				</TableCell>
			</TableRow>

			{expendable &&
				<TableRow style={{ height: showAssignments ? 'auto' : 0 }}>
					<TableCell style={{ paddingBottom: 0, paddingTop: 0, height: showAssignments ? 'auto' : 0 }} colSpan={2}>
						<Collapse in={showAssignments} timeout="auto" unmountOnExit>
							<Typography variant="h6" gutterBottom component="div">

							</Typography>
						</Collapse>
					</TableCell>

					<TableCell style={{ paddingBottom: 0, paddingTop: 0, height: showAssignments ? 'auto' : 0 }} colSpan={(!navigateStore.simpleMode ? 9 : 7)}>
						<Collapse in={showAssignments} timeout="auto" unmountOnExit>
							<Typography variant="h6" gutterBottom component="div">
								asaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa.aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaassdfasdfdffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffsssssssssssssssssssffs..
							</Typography>
						</Collapse>
					</TableCell>
				</TableRow>
			}
		</>
	);
}

export default TemplateProjectListRows;
